import React from "react";
import ReactEcharts from "echarts-for-react";
import echarts from "echarts";
import { getBrandknowledgeKey, MEETING_NUMBERS_FULL } from "../utils";
import { filter, reduce } from "lodash-es";
import {
  WHINE_RED,
  LIGHTER_WHINE_RED,
  DARKER_PURPLE,
  DARKER_WHINE_RED,
  REDISH,
  NEON_BLUE,
  BRUNISH,
  FOREST_GREEN_DARK,
  FOREST_GREEN_MEDIUM,
  FOREST_GREEN_LIGHT,
  LIGHTER_PURPLE,
  MINT_GREEN_LIGHT,
  MINT_GREEN_MEDIUM,
  MINT_GREEN_DARK,
  BRAND_GRAY_DARK,
  BRAND_GRAY_MEDIUM,
  BRAND_GRAY_LIGHT,
  BRAND_PURPLE_DARK,
  BRAND_PURPLE_MEDIUM,
  BRAND_PURPLE_LIGHT,
  BRAND_BLUE,
  BRAND_BLUE_LIGHT,
  BRAND_BLUE_LIGHTEST,
  TEXT_GRAY,
} from "../theme/colors";
import { useTranslation } from "react-i18next";
import { es, is } from "date-fns/locale";
const colorObj = {
  primary: {
    color: [FOREST_GREEN_DARK, FOREST_GREEN_MEDIUM],
    shadowColor: FOREST_GREEN_DARK,
    symbolOffset: [-20, 0],
  },
  recommending: {
    color: [MINT_GREEN_DARK, MINT_GREEN_MEDIUM],
    shadowColor: MINT_GREEN_DARK,
    symbolOffset: [-10, 0],
  },
  testing: {
    color: [MINT_GREEN_LIGHT, MINT_GREEN_MEDIUM],
    shadowColor: MINT_GREEN_LIGHT,
    symbolOffset: [0, 0],
  },
  understands: {
    color: [BRAND_GRAY_MEDIUM, BRAND_GRAY_LIGHT],
    shadowColor: BRAND_GRAY_MEDIUM,
    symbolOffset: [10, 0],
  },
  knowledge: {
    color: [LIGHTER_PURPLE, BRAND_GRAY_MEDIUM],
    shadowColor: BRAND_GRAY_LIGHT,
    symbolOffset: [20, 0],
  },
  none: {
    color: [BRAND_PURPLE_DARK, BRAND_PURPLE_MEDIUM],
    shadowColor: BRAND_PURPLE_DARK,
    symbolOffset: [30, 0],
  },
  ej_intresserad_nu: {
    color: [BRAND_BLUE_LIGHT, BRAND_BLUE_LIGHTEST],
    shadowColor: BRAND_BLUE_LIGHT,
    symbolOffset: [30, 0],
  },
  visst_intresse: {
    color: [BRAND_BLUE_LIGHTEST, BRAND_BLUE_LIGHT],
    shadowColor: BRAND_BLUE_LIGHTEST,
    symbolOffset: [30, 0],
  },
  hogt_intresse: {
    color: [MINT_GREEN_MEDIUM, MINT_GREEN_DARK],
    shadowColor: MINT_GREEN_MEDIUM,
    symbolOffset: [30, 0],
  },
  ska_bestalla: {
    color: [MINT_GREEN_LIGHT, MINT_GREEN_MEDIUM],
    shadowColor: MINT_GREEN_LIGHT,
    symbolOffset: [30, 0],
  },
  lagt_bestallning: {
    color: [BRAND_GRAY_DARK, BRAND_GRAY_MEDIUM],
    shadowColor: BRAND_GRAY_DARK,
    symbolOffset: [30, 0],
  },
  kan_ej_bestalla: {
    color: [BRAND_PURPLE_LIGHT, BRAND_PURPLE_MEDIUM],
    shadowColor: BRAND_PURPLE_LIGHT,
    symbolOffset: [30, 0],
  },
  expedites_regularly: {
    color: [BRAND_GRAY_MEDIUM, BRAND_GRAY_LIGHT],
    shadowColor: BRAND_GRAY_MEDIUM,
    symbolOffset: [0, 0],
  },
  expedites_sometimes: {
    color: [BRAND_PURPLE_DARK, BRAND_PURPLE_MEDIUM],
    shadowColor: BRAND_PURPLE_DARK,
    symbolOffset: [10, 0],
  },
  no_knowledge: {
    color: [BRAND_PURPLE_DARK, BRAND_PURPLE_MEDIUM],
    shadowColor: BRAND_PURPLE_DARK,
    symbolOffset: [30, 0],
  },
  unknown: {
    color: [NEON_BLUE, DARKER_PURPLE],
    shadowColor: NEON_BLUE,
    symbolOffset: [15, 0],
  },
};

const generateSeriesPoint = (key, name, data, N) => {
  return {
    name: name,
    data: data,
    symbolSize: function (data) {
      const size = 1 + (data / N) * 100;
      const symbSize = Math.sqrt(Math.log2(size)) * 15;
      return !data ? 0 : symbSize;
    },
    type: "scatter",
    symbolOffset: colorObj[key].symbolOffset,
    itemStyle: {
      opacity: 0.2,
      normal: {
        // shadowBlur: 10,
        // shadowColor: colorObj[key].shadowColor, //'rgba(2, 164, 153, 0.5)',
        // shadowOffsetY: 5,
        color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [
          {
            offset: 0,
            color: colorObj[key].color[0],
          },
          // {
          //   offset: 1,
          //   color: colorObj[key].color[1],
          // },
        ]),
      },
    },
    // center: colorObj[key].centerOffset,
    label: {
      emphasis: {
        show: true,
        // formatter: formatBrandKnowledge(key),
        formatter: function (param) {
          return param.data;
        },
        position: "top",
      },
    },
  };
};

const ProductKnowledgeChart = ({
  isRx,
  isVet,
  data,
  brandKnowledgeKeys,
  use7Meetings = false,
}) => {
  const { t } = useTranslation();

  const getCorrectBrandKnowledge = (item) => {
    return isRx ? item.brandKnowledgeRX : item.brandKnowledge;
  };

  const meetings = reduce(
    brandKnowledgeKeys,
    (obj, prKnowledge) => {
      const meetingNumbers = MEETING_NUMBERS_FULL;
      const meetingData = meetingNumbers.map((meetingNr) => {
        const meetingData = filter(data, (item) => {
          return (
            item.meetingNumber &&
            getCorrectBrandKnowledge(item) &&
            item.meetingNumber.toString() === meetingNr &&
            prKnowledge === getCorrectBrandKnowledge(item)
          );
        });

        return meetingData.length;
      });
      return { ...obj, [prKnowledge]: meetingData };
    },
    {},
  );

  const valueArray = Object.values(meetings).flat();
  const calculatedN = Math.max(...valueArray);

  const series = brandKnowledgeKeys.map(
    (key) =>
      generateSeriesPoint(
        key,
        t(`brand_knowledge.${getBrandknowledgeKey(key, isVet)}`),
        meetings[key],
        calculatedN,
      ),
    // {t(`brand_knowledge.${data.pharmacyName}`)}
  );
  const getOption = () => {
    return {
      toolbox: {
        show: false,
      },
      legend: {
        align: "right",
        right: 0,
        orient: "vertical",
        top: 0,
        data: brandKnowledgeKeys.map((key) =>
          t(`brand_knowledge.${getBrandknowledgeKey(key, isVet)}`),
        ),
      },
      grid: {
        left: "5%",
        bottom: "10%",
        top: "15%",
        right: "20%",
        borderWidth: 0,
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "rgba(0,0,0,0)",
      },
      xAxis: {
        splitLine: {
          lineStyle: {
            type: "dashed",
          },
        },
        axisLine: {
          lineStyle: {
            color: TEXT_GRAY,
          },
        },
        type: "category",
        data: [
          t("meeting.1"),
          t("meeting.2"),
          t("meeting.3"),
          t("meeting.4"),
          t("meeting.5"),
          t("meeting.6"),
          t("meeting.7"),
        ],
      },
      yAxis: {
        boundaryGap: true,
        name: "Antal",

        scale: true,
        axisLine: {
          lineStyle: {
            color: TEXT_GRAY,
          },
        },
      },
      series: series,
      color: ["#00bbaa"],
    };
  };

  return (
    <React.Fragment>
      <ReactEcharts option={getOption()} />
    </React.Fragment>
  );
};
export default ProductKnowledgeChart;
